import React, { useRef, useState } from "react";
import classes from "./styles.module.css";

export type CustomOtpBoxInputProps = {
  disabled?: boolean;
  value: string;
  setValue: React.Dispatch<React.SetStateAction<string>>;
  otpContainerStyles?: React.CSSProperties;
};

const CustomBoxOtpInput: React.FC<CustomOtpBoxInputProps> = ({
  disabled,
  value,
  setValue,
  otpContainerStyles
}: CustomOtpBoxInputProps) => {
  const [focusedInput, setFocusedInput] = useState<number>(-1);
  const otpTextInputRef = useRef<HTMLInputElement | null>(null);

  const handleValueChange = (val: string) => {
    const value = val
      .replace(/[^0-9\s]/g, "")
      .replace(/\s/g, "")
      .substring(0, 6);
    const len = value.length;
    setValue(value);
    setFocusedInput(len);
  };

  const handleInputFocus = (i: number) => {
    otpTextInputRef.current?.focus();
    setFocusedInput(i);
  };

  const showInputBoxStyles = focusedInput !== -1 || value !== "";

  const renderBoxes = () => {
    const views = [];
    for (let i = 0; i < 6; i++) {
      views.push(
        <div
          key={i}
          className={classes.otpBox}
          data-isfilled={!!value[i]}
          data-showinputstyles={showInputBoxStyles}
          data-isdisabled={disabled}
          data-isfocused={focusedInput === i}
          style={{
            background: "#0D111C"
          }}
          onClick={() => !disabled && handleInputFocus(value.length)}>
          {value.substring(i, i + 1)}
        </div>
      );
    }
    return views;
  };

  return (
    <div style={{ width: "100%", display: "block" }}>
      <div style={otpContainerStyles} className={classes.otpContainer}>
        {renderBoxes()}
        <input
          disabled={disabled}
          ref={(el) => {
            otpTextInputRef.current = el;
          }}
          className={classes.input}
          autoFocus
          value={value}
          onChange={(e) => handleValueChange(e.target.value)}
          onFocus={() => {
            setFocusedInput(value.length);
            otpTextInputRef.current?.focus();
          }}
          onKeyDown={(e) => {
            if (
              e.key === "ArrowDown" ||
              e.key === "ArrowUp" ||
              e.key === "ArrowLeft" ||
              e.key === "ArrowRight"
            )
              e.preventDefault();
          }}
          onBlur={() => {
            setFocusedInput(-1);
            otpTextInputRef.current?.blur();
          }}
          maxLength={11}
        />
      </div>
    </div>
  );
};

export default CustomBoxOtpInput;
